import script from "./LicenseWindowAuthorizedUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseWindowAuthorizedUsers.vue?vue&type=script&setup=true&lang=js"

import "./LicenseWindowAuthorizedUsers.vue?vue&type=style&index=0&id=38e61cab&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38e61cab"]])

export default __exports__